// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Experiment in using the new nesting operator */

.ecl-block-form {
    padding: 10px;
    margin: 5px;
    border: var(--border);
    border-radius: var(--border-radius);
    background-color: var(--sub-window-bg);

    & label:first-of-type {
        padding-top: 0px;
    }

    & label {
        text-transform: capitalize;
    }

    & .form-block-ontology-label {
        font-size: 1.25rem;
    }

    & .form-object-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: larger;

    }

    & .form-object-container {
        padding: 0px 15px;
        margin: 5px;
        overflow: auto;
    }

    & .form-object-combo-header {
        display: flex;
        justify-content: space-between;

    }

    & .form-object-instance-combo {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        width: 100%;
    }

    
    & .form-input-fieldset-container {
        width: 100%;
        margin-bottom: 5px;
    }

    & .form-input-fieldset-container:has(+ button) {
        width: calc(100% - 40px);
    }

    & .form-input-fieldset-container:only-child {
        margin-bottom: 0px;
    }

    /* Great tower of fieldsets.  Need to alternate colors like so for nested fieldsets */
    & fieldset {
        border: var(--border);
        background-color: var(--window-bg);
        display: flex;
        padding: 5px;
        flex-direction: column;

        & .form-object-container {
            margin-bottom: 0px;
        }

        & label:first-of-type {
            padding-top: 0px;
        }

        & fieldset {
            background-color: var(--sub-window-bg);

            & label:first-of-type {
                padding-top: 0px;
            }

            & fieldset {
                background-color: var(--window-bg);

                & label:first-of-type {
                    padding-top: 0px;
                }

                & fieldset {
                    background-color: var(--sub-window-bg);

                    & label:first-of-type {
                        padding-top: 0px;
                    }
                }
            }
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/ECLBlockument/Blocks/ECLFormBlock/ECLFormWrapper.css"],"names":[],"mappings":"AAAA,iDAAiD;;AAEjD;IACI,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,mCAAmC;IACnC,sCAAsC;;IAEtC;QACI,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,iBAAiB;;IAErB;;IAEA;QACI,iBAAiB;QACjB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,aAAa;QACb,8BAA8B;;IAElC;;IAEA;QACI,aAAa;QACb,yBAAyB;QACzB,qBAAqB;QACrB,WAAW;IACf;;;IAGA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,kBAAkB;IACtB;;IAEA,qFAAqF;IACrF;QACI,qBAAqB;QACrB,kCAAkC;QAClC,aAAa;QACb,YAAY;QACZ,sBAAsB;;QAEtB;YACI,kBAAkB;QACtB;;QAEA;YACI,gBAAgB;QACpB;;QAEA;YACI,sCAAsC;;YAEtC;gBACI,gBAAgB;YACpB;;YAEA;gBACI,kCAAkC;;gBAElC;oBACI,gBAAgB;gBACpB;;gBAEA;oBACI,sCAAsC;;oBAEtC;wBACI,gBAAgB;oBACpB;gBACJ;YACJ;QACJ;IACJ;AACJ","sourcesContent":["/* Experiment in using the new nesting operator */\r\n\r\n.ecl-block-form {\r\n    padding: 10px;\r\n    margin: 5px;\r\n    border: var(--border);\r\n    border-radius: var(--border-radius);\r\n    background-color: var(--sub-window-bg);\r\n\r\n    & label:first-of-type {\r\n        padding-top: 0px;\r\n    }\r\n\r\n    & label {\r\n        text-transform: capitalize;\r\n    }\r\n\r\n    & .form-block-ontology-label {\r\n        font-size: 1.25rem;\r\n    }\r\n\r\n    & .form-object-label {\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        font-size: larger;\r\n\r\n    }\r\n\r\n    & .form-object-container {\r\n        padding: 0px 15px;\r\n        margin: 5px;\r\n        overflow: auto;\r\n    }\r\n\r\n    & .form-object-combo-header {\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n    }\r\n\r\n    & .form-object-instance-combo {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n        align-items: flex-end;\r\n        width: 100%;\r\n    }\r\n\r\n    \r\n    & .form-input-fieldset-container {\r\n        width: 100%;\r\n        margin-bottom: 5px;\r\n    }\r\n\r\n    & .form-input-fieldset-container:has(+ button) {\r\n        width: calc(100% - 40px);\r\n    }\r\n\r\n    & .form-input-fieldset-container:only-child {\r\n        margin-bottom: 0px;\r\n    }\r\n\r\n    /* Great tower of fieldsets.  Need to alternate colors like so for nested fieldsets */\r\n    & fieldset {\r\n        border: var(--border);\r\n        background-color: var(--window-bg);\r\n        display: flex;\r\n        padding: 5px;\r\n        flex-direction: column;\r\n\r\n        & .form-object-container {\r\n            margin-bottom: 0px;\r\n        }\r\n\r\n        & label:first-of-type {\r\n            padding-top: 0px;\r\n        }\r\n\r\n        & fieldset {\r\n            background-color: var(--sub-window-bg);\r\n\r\n            & label:first-of-type {\r\n                padding-top: 0px;\r\n            }\r\n\r\n            & fieldset {\r\n                background-color: var(--window-bg);\r\n\r\n                & label:first-of-type {\r\n                    padding-top: 0px;\r\n                }\r\n\r\n                & fieldset {\r\n                    background-color: var(--sub-window-bg);\r\n\r\n                    & label:first-of-type {\r\n                        padding-top: 0px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
